/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { AxiosPromise, AxiosResponse, CancelToken } from 'axios';
import { injectable } from '@servicetitan/react-ioc';
import { MockResponseConfig } from 'utils';
import {
    // @ts-ignore: noUnusedLocals on imported objects in __mocks__
    IPasswordValidation,
    // @ts-ignore: noUnusedLocals on imported objects in __mocks__
    ValidatePasswordRequest
} from '../password-validator.api';

@injectable()
export class PasswordValidationMock implements IPasswordValidation {
    private handleCall<T>(config: MockResponseConfig<T> | null | undefined): AxiosPromise<T> {
        if (!config) {
            throw new Error('Mock not configured');
        }
        if (typeof config.responseCount === 'number') {
            if (config.responseCount === 0) {
                throw new Error('Mock exceeded allowed response count');
            }
            config.responseCount = config.responseCount - 1;
        }
        if (config.error && config.response) {
            throw new Error('Mock has both response and error configured');
        }
        if (config.error) {
            return Promise.reject(config.error);
        }
        if (config.response) {
            return Promise.resolve(config.response as AxiosResponse<T>);
        }
        throw new Error('Mock configuration missing reponse');
    }

    private validatePasswordConfig: MockResponseConfig<boolean> | null | undefined;
    validatePasswordConfigure(config: MockResponseConfig<boolean> | null): void {
        this.validatePasswordConfig = config;
    }
    validatePassword(_0: ValidatePasswordRequest, _1?: CancelToken): AxiosPromise<boolean> {
        return this.handleCall(this.validatePasswordConfig);
    }
}
